import { AttachmentPolicy } from '@core/interfaces/attachment.interface';

export function acceptAttachments(
  files: File[],
  policy: AttachmentPolicy,
  currentCount: number,
): File[] {
  const room = policy.maxCount - currentCount;
  if (room <= 0) return [];
  return files
    .filter((f) => policy.acceptedMimeTypes.includes(f.type))
    .filter((f) => f.size <= policy.maxSizeBytes)
    .slice(0, room);
}
